import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uimdx"
    }}>{`@theme-ui/mdx`}</h1>
    <p>{`MDX component context for Theme UI`}</p>
    <p><a parentName="p" {...{
        "href": "https://theme-ui.com"
      }}>{`https://theme-ui.com`}</a></p>
    <p><strong parentName="p">{`Note:`}</strong>{` `}<em parentName="p">{`This package is included in the main `}<inlineCode parentName="em">{`theme-ui`}</inlineCode>{` package and a separate installation is not required.`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/mdx
`}</code></pre>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`themed`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Themed`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`components`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`MDXProvider`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      